import { AxiosInstance } from "axios"
import {
    MessageDetails,
    MessageItem,
    MessagePublishType,
    ServiceCenterMessage,
    ServiceCenterMessageAdditionalData,
} from "./serviceCenterMessagesTypes"
import { ServiceResponse } from "../../../../core/api/apiTypes"

export enum ServiceCenterMessagesQuery {
    LIST = "messages-for-service-center",
    DETAILS = "message-details-for-service-center",
}

type FetchServiceCenterMessagesParams = Readonly<{
    serviceCenterId: number
    publishType: MessagePublishType
}>

export type FetchServiceCenterMessagesResponse = Readonly<{
    messages: ServiceCenterMessage[]
}>

export async function fetchServiceCenterMessages(
    { serviceCenterId, publishType }: FetchServiceCenterMessagesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchServiceCenterMessagesResponse> {
    const url = `/serviceCenters/${serviceCenterId}/messages`

    const { data } = await axios.get(url, {
        params: {
            publishType,
        },
        signal,
    })

    return data
}

type DeleteServiceCenterMessageParam = Readonly<{
    messageId: number
}>

export async function deleteServiceCenterMessage(
    { messageId }: DeleteServiceCenterMessageParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/messages/${messageId}`, {
        signal,
    })
    return data
}

type ServiceCenterMessageParam = Readonly<{
    messageId: string
}>

export type FetchServiceCenterMessageResponse = Readonly<{
    message: MessageDetails
}>

export async function fetchServiceCenterMessage(
    { messageId }: ServiceCenterMessageParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchServiceCenterMessageResponse> {
    const url = `/messages/${messageId}`

    const { data } = await axios.get(url, {
        signal,
    })
    return data
}

export async function createServiceCenterMessage(
    {
        message,
        messageAdditionalData,
    }: { message: MessageItem; messageAdditionalData: ServiceCenterMessageAdditionalData },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/messages`,
        {
            message: { ...message, ...messageAdditionalData },
        },
        {
            signal,
        },
    )
    return data
}

export async function updateServiceCenterMessage(
    { message, messageId }: { message: MessageItem; messageId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/messages/${messageId}`,
        {
            message,
        },
        {
            signal,
        },
    )
    return data
}
